
export default function InquiryBadgeList({
    query,
    setQuery,
    user,
    availableSites,
    isAdminMode,
    setIsAdminMode,
    adminTargetSubdomain,
    setAdminTargetSubdomain,
    hasPermission,
    isTest,
    pageReset,
}) {
    const Badge = ({ active, label, onClick }) => (
        <div
            onClick={onClick}
            className={`
                px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-all duration-200 select-none
                ${active
                    ? "bg-[#f6475f] text-white shadow-sm ring-2 ring-[#f6475f] ring-offset-1"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }
            `}
            style={{ fontFamily: "Gmarket-M" }}
        >
            {label}
        </div>
    );

    const SiteSection = ({ title, typeId }) => {
        const sites = availableSites.filter((siteType) => siteType.type.id === typeId);
        if (sites.length === 0) return null;

        return (
            <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center mt-4">
                <h4 className="text-sm font-bold text-[#f6475f] w-16 shrink-0" style={{ fontFamily: "Gmarket-M" }}>{title}</h4>
                <div className="flex flex-wrap gap-2">
                    {sites.map((site, index) => (
                        <Badge
                            key={index}
                            active={adminTargetSubdomain === site.subdomain}
                            label={site.short_name}
                            onClick={() => {
                                setAdminTargetSubdomain(adminTargetSubdomain === site.subdomain ? "" : site.subdomain);
                                setIsAdminMode(true);
                                pageReset();
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="w-full">
            <div className="flex flex-wrap gap-2 mb-4">
                {hasPermission && (
                    <>
                        <Badge
                            active={query.no_reply}
                            label="답변필요"
                            onClick={() => setQuery(prev => ({ ...prev, no_reply: !query.no_reply ? "True" : "", page: 1 }))}
                        />
                        <Badge
                            active={query.need_care}
                            label="확인필요"
                            onClick={() => setQuery(prev => ({ ...prev, need_extra_info: !query.need_care ? "True" : "", need_care: !query.need_care ? "True" : "", page: 1 }))}
                        />
                    </>
                )}

                {isTest && hasPermission && (
                    <Badge
                        active={isAdminMode}
                        label="관리자보기"
                        onClick={() => {
                            setIsAdminMode(!isAdminMode);
                            setAdminTargetSubdomain("");
                            pageReset();
                        }}
                    />
                )}

                <Badge
                    active={query.my_article}
                    label="내가쓴글"
                    onClick={() => setQuery(prev => ({ ...prev, phone_num: !query.my_article ? user?.phone : "", my_article: !query.my_article ? "True" : "", page: 1 }))}
                />
            </div>

            {isTest && hasPermission && (
                <div className="border-t border-gray-100 pt-3 mt-2">
                    <SiteSection title="캠프" typeId={1} />
                    <SiteSection title="파크" typeId={2} />
                    <SiteSection title="바베큐" typeId={5} />
                </div>
            )}
        </div>
    );
}